import { Slide, ToastContainer } from 'react-toastify';

const Toaster = () => {
  return (
    <ToastContainer
      className="p-2 toastify-container"
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      transition={Slide}
    />
  );
};

export default Toaster;
